import { produce } from 'immer';
import { types as authActionTypes } from '../actions/auth';
import { types as apiActionTypes } from '../actions/api';
var initialState = {
    authenticated: false,
    error: undefined,
    token: undefined,
    userId: undefined,
    userLogin: undefined,
    apps: [],
    selectedApp: undefined,
    authenticating: false,
    selectingApp: false,
    loggingOut: false,
    userInfo: {},
    userProperties: {}
};
var authenticating = function (state) {
    return produce(state, function (draftState) {
        draftState.authenticating = true;
    });
};
var loggingOut = function (state) {
    return produce(state, function (draftState) {
        draftState.loggingOut = true;
    });
};
var loginSuccess = function (payload) {
    var token = payload.token, userId = payload.userId, login = payload.login, apps = payload.apps;
    return {
        authenticated: true,
        error: undefined,
        token: token,
        userId: userId,
        userLogin: login,
        apps: apps,
        selectedApp: apps.length === 1 ? apps[0] : undefined,
        authenticating: false,
        selectingApp: false,
        loggingOut: false,
    };
};
var authenticateWithToken = function (payload) {
    var token = payload.token;
    return {
        authenticated: true,
        error: undefined,
        token: token,
        userId: '',
        userLogin: '',
        apps: [],
        selectedApp: undefined,
        authenticating: false,
        selectingApp: false,
        loggingOut: false,
    };
};
var loginError = function (payload) { return ({
    authenticated: false,
    error: payload.error || true,
    token: undefined,
    userId: undefined,
    userLogin: undefined,
    apps: [],
    selectedApp: undefined,
    authenticating: false,
    selectingApp: false,
    loggingOut: false,
}); };
var logoutSuccess = function () { return ({
    authenticated: false,
    error: undefined,
    token: undefined,
    userId: undefined,
    userLogin: undefined,
    apps: [],
    selectedApp: undefined,
    authenticating: false,
    selectingApp: false,
    loggingOut: false,
}); };
var logoutError = function (state, payload) {
    return produce(state, function (draftState) {
        var error = payload.error;
        draftState.loggingOut = false;
        draftState.error = error;
    });
};
var setUserInfo = function (state, payload) { return produce(state, function (draftState) {
    console.log({ payload: payload });
    var userInfo = payload.userInfo;
    draftState.userInfo = userInfo.data;
}); };
var setUserProperties = function (state, payload) { return produce(state, function (draftState) {
    console.log({ payload: payload });
    var userProperties = payload.userProperties;
    draftState.userProperties = userProperties.data;
}); };
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case authActionTypes.AUTHENTICATING:
            return authenticating(state);
        case authActionTypes.LOGGING_OUT:
            return loggingOut(state);
        case authActionTypes.LOGIN_SUCCESS:
            return loginSuccess(payload);
        case authActionTypes.LOGIN_ERROR:
            return loginError(payload);
        case authActionTypes.LOGOUT_SUCCESS:
            return logoutSuccess();
        case authActionTypes.LOGOUT_ERROR:
            return logoutError(state, payload);
        case apiActionTypes.SET_USER_INFO:
            return setUserInfo(state, payload);
        case apiActionTypes.SET_USER_PROPERTIES:
            return setUserProperties(state, payload);
        case authActionTypes.AUTHORIZE_WITH_TOKEN:
            return authenticateWithToken(payload);
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=auth.js.map